var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/prop-types */
import * as React from "react";
import classNames from "classnames";
class Checkbox extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = (e) => {
            const { disabled, onChange } = this.props;
            if (disabled) {
                return;
            }
            if (!("checked" in this.props)) {
                this.setState({
                    checked: e.target.checked,
                });
            }
            if (onChange) {
                onChange({
                    target: Object.assign(Object.assign({}, this.props), { checked: e.target.checked }),
                    stopPropagation() {
                        e.stopPropagation();
                    },
                    preventDefault() {
                        e.preventDefault();
                    },
                    nativeEvent: e.nativeEvent,
                });
            }
        };
        this.saveInput = (node) => {
            this.input = node;
        };
        const checked = "checked" in props ? props.checked : props.defaultChecked;
        this.state = {
            checked,
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if ("checked" in nextProps && nextProps.checked !== prevState.checked) {
            return {
                checked: nextProps.checked,
            };
        }
        return null;
    }
    focus() {
        this.input.focus();
    }
    blur() {
        this.input.blur();
    }
    render() {
        const _a = this.props, { prefixCls, className, style, name, id, type, disabled, readOnly, tabIndex, onClick, onFocus, onBlur, autoFocus, value, required } = _a, others = __rest(_a, ["prefixCls", "className", "style", "name", "id", "type", "disabled", "readOnly", "tabIndex", "onClick", "onFocus", "onBlur", "autoFocus", "value", "required"]);
        const globalProps = Object.keys(others).reduce((prev, key) => {
            if (key.substr(0, 5) === "aria-" || key.substr(0, 5) === "data-" || key === "role") {
                ;
                prev[key] = others[key];
            }
            return prev;
        }, {});
        const { checked } = this.state;
        const classString = classNames(prefixCls, className, {
            [`${prefixCls}-checked`]: checked,
            [`${prefixCls}-disabled`]: disabled,
        });
        return (<span className={classString} style={style}>
        <input name={name} id={id} type={type} required={required} readOnly={readOnly} disabled={disabled} tabIndex={tabIndex} className={`${prefixCls}-input`} checked={!!checked} onClick={onClick} onFocus={onFocus} onBlur={onBlur} onChange={this.handleChange} autoFocus={autoFocus} ref={this.saveInput} value={value} {...globalProps}/>
        <span className={`${prefixCls}-inner`}/>
      </span>);
    }
}
Checkbox.defaultProps = {
    prefixCls: "rp-checkbox",
    className: "",
    style: {},
    type: "checkbox",
    defaultChecked: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onFocus() { },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onBlur() { },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange() { },
};
export default Checkbox;
